import { gsap, Power2 } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger.js'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin.js'
import { closePopup } from './popup'
import { animateIntro } from './content-animations'
import { initSequence } from './intro-sequence-animation'
import { gsapClickLazySet } from './gsap-lazy'

gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(ScrollToPlugin)

let $body = $('body')

let screenWidth = window.innerWidth
let navigation_blocks = $('.menu a')
let scroll_triggers = $('[data-menu-id]')
let menu_timeline = gsap.timeline({ repeat: -1, force3D: false })

function toggleMenu()
{
  $('.hamburger').toggleClass('is-active')
  $('.js-toggle-menu .title').toggleClass('d-none')
  $('header').toggleClass('is-visible')
  $('html').toggleClass('menu-open')
}

function setupMenuAnimation()
{

  navigation_blocks.each(function (k, v) {

    let navURL = $(this).attr('href')
    let navName = navURL.split('#')[1]

    menu_timeline.set('.menu li a', { className: '+=not-active' })

    if(navName && navName.length > 0) {

      $(this).parent().addClass(navName)
      $(this).attr('data-menu-nav', '#' + navName)
      menu_timeline.add('#' + navName)

      menu_timeline.to('.' + navName + ' a', { className: '+=is-active' })

      menu_timeline.addPause()
      menu_timeline.to('.' + navName + ' a', { className: '+=not-active' })

    }

  })

  function playNav (e) {

    let navName = $(e.trigger).attr('data-menu-id')
    if (navName && navName.length) {



      if($(e.trigger).hasClass('fines-block')) {
        $body.addClass('is-highlighted-block')
        $('.fines-tabs-buttons, .fines-tabs-containers').addClass('animate-in')
        if(screenWidth < 1024) {
          gsap.fromTo('.fines-tabs .swiper-wrapper', { x: 50 }, { duration: 0.5, x: 0})
        }
      } else {
        $body.removeClass('is-highlighted-block')
      }
      menu_timeline.play(navName, false)
    }
  }

  function scrollTo (menuID) {
    gsap.to(window, {
      duration: 0.05,
      scrollTo: {
        y: '[data-menu-id="' + menuID + '"]',
        offsetY: 60,
      },
      ease: 'none',
      force3D: false,
    })

    history.pushState({}, null, '/')
  }

  function removeIntro18()
  {
    $('.intro-18-check').hide()
    $('html').removeClass('has-intro-check')
    animateIntro()
    initSequence()
    gsapClickLazySet()

  }


  scroll_triggers.each(function (e) {


    ScrollTrigger.create({
      trigger: this,
      start: 'top center+=10',
      end: 'bottom center-=10',
      onEnter: playNav,
      onEnterBack: playNav,
      //markers: true
    })

  })

  $('body').on('click', '.js-accept-18', function (e){
    e.preventDefault()
    removeIntro18()
  })

  $('body').on('click', '[data-menu-nav]', function (e){
    e.preventDefault()

    let menuID = $(this).attr('data-menu-nav')

    if($(this).hasClass('remove-intro')){
      removeIntro18()
    }

    if($('[data-menu-id="'+menuID+'"]').length) {
      menu_timeline.play(menuID)
      scrollTo(menuID)
    }

    if ($('.hamburger').hasClass('is-active')) {
      toggleMenu()
    }

    setTimeout(function (){
      closePopup()
    }, 400)


  })

  if(location.hash && location.hash.length > 1) {
    let menuID = location.hash.substring(1)
    if(menuID.length > 0 && $('[data-menu-id="#'+menuID+'"]').length) {
      menu_timeline.play('#' + menuID)
      scrollTo('#' + menuID)
    }

  }

}

$body.on('click', '.js-toggle-menu', function (e){
  e.preventDefault()
  toggleMenu()
})

$(window).on('load', function (e){
  setupMenuAnimation()
})


